import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
//import { gsap } from 'gsap';
import Treatments from '../components/TreatmentsOffered';
import Procedures from '../components/Procedures';
import Footer from '../components/Footer';

const Home = () => {
 // const expertTextRef = useRef();
  const bookAppointmentRef = useRef();
  // const bookAppointment1Ref = useRef();
  
  // Framer Motion variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  const scaleUp = {
    hidden: { scale: 0.95, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 1 } }
  };

  const staggerContainer = {
    visible: { 
      transition: { 
        staggerChildren: 0.1 
      } 
    }
  };
useEffect(() => {
    let direction = 1;
    let pos = 0;

    const interval = setInterval(() => {
      pos += direction;
      if (pos > 20) direction = -1;
      if (pos < -10) direction = 1;
      if (bookAppointmentRef.current) {
        bookAppointmentRef.current.style.transform = `translateY(-${pos}px)`;
      }
    }, 30);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      {/* Add fonts to match navbar */}
      <link 
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&family=Cormorant+Garamond:wght@400;500;600;700&display=swap" 
        rel="stylesheet"
      />
      
      {/* Hero Section - Improved mobile layout */}
<section className="relative bg-teal-50 py-12 md:py-20 lg:py-16 overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-center">
      {/* Text content */}
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.1
            }
          }
        }}
        className="hero-content order-2 md:order-1"
      >
        <motion.h1 
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { 
              opacity: 1, 
              x: 0,
              transition: {
                duration: 0.6,
                ease: "easeOut"
              }
            }
          }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-teal-900 leading-tight"
          
        >
         <div   style={{ fontFamily: "'Cormorant Garamond', serif" }}>
  Expert <br /> 
  <span className="text-teal-600">Dermatological <br /></span> Care
</div>
        </motion.h1>
        
        <motion.p 
          variants={{
            hidden: { opacity: 0, x: -30 },
            visible: { 
              opacity: 1, 
              x: 0,
              transition: {
                delay: 0.3,
                duration: 0.5,
                ease: "easeOut"
              }
            }
          }}
          className="mt-4 sm:mt-6 text-base sm:text-lg text-teal-800 font-medium max-w-lg"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Personalized skincare solutions and advanced treatments for healthy, radiant skin.
        </motion.p>
        
        <motion.div 
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { 
              opacity: 1, 
              y: 0,
              transition: {
                delay: 0.5,
                duration: 0.5,
                ease: "easeOut"
              }
            }
          }}
          className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-3 w-full max-w-md"
        >
          <Link 
            to="/treatments" 
            className="px-6 py-3 bg-teal-600 text-white hover:bg-teal-700 rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg text-center flex-1"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}
          >
            Our Treatments
          </Link>
          <Link 
            to="/contact" 
            ref={bookAppointmentRef}
            className="px-6 py-3 border-2 border-teal-600 text-teal-600 hover:bg-teal-50 rounded-lg font-medium transition-all duration-300 hover:shadow-md text-center flex-1"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}
          >
            Book Appointment
          </Link>
        </motion.div>
      </motion.div>
      
      {/* Image with Sophisticated Overlay */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ 
          opacity: 1, 
          scale: 1,
          transition: {
            delay: 0.2,
            duration: 0.6,
            ease: "easeOut"
          }
        }}
        className="relative w-full h-full min-h-[300px] md:min-h-[400px] rounded-xl overflow-hidden group order-1 md:order-2"
      >
        <picture>
  <source media="(max-width: 768px)" srcSet="/Images/Doctor-Patient-mobile.webp" />
  <source media="(min-width: 769px)" srcSet="/Images/Doctor-Patient.webp" />
  <img 
    src="/Images/Doctor-Patient.webp" 
    alt="Dermatologist with patient" 
    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
    loading="eager"
  />
</picture>

        
        {/* Elegant Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/60 flex flex-col justify-end p-6 md:p-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: {
                delay: 0.8,
                duration: 0.5
              }
            }}
          >
            <h2 
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 tracking-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}
            >
              Dr Nidhi's 
            </h2>
            <h3 
              className="text-xl sm:text-2xl text-teal-200 font-medium mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif", textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}
            >
              Estheelite Skin & Hair Clinic
            </h3>
            <div className="w-16 h-0.5 bg-teal-300 mb-4 opacity-90"></div>
            <p className="text-teal-50 text-sm sm:text-base opacity-90" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Specialized care for your skin's natural beauty
            </p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  </div>
</section>



      {/* Doctor Profile Section - Improved responsive layout */}
      <section className="py-12 md:py-20 lg:py-24 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: { opacity: 0 },
              visible: { 
                opacity: 1,
                transition: { staggerChildren: 0.1 }
              }
            }}
            className="relative"
          >
            {/* Decorative elements */}
            <div className="absolute -left-20 -top-20 w-64 h-64 rounded-full bg-teal-400 opacity-10 mix-blend-multiply blur-xl hidden md:block"></div>
            <div className="absolute -right-20 -bottom-20 w-72 h-72 rounded-full bg-teal-600 opacity-10 mix-blend-multiply blur-xl hidden md:block"></div>

            {/* Main card */}
            <motion.div 
              variants={scaleUp}
              className="bg-gradient-to-br from-teal-700 to-teal-900 rounded-2xl lg:rounded-3xl shadow-2xl overflow-hidden border-8 border-white/10 relative"
            >
              <div className="absolute inset-0 overflow-hidden">
                <div className="absolute inset-0 bg-teal-800/10"></div>
                <div 
                  className="absolute -right-20 -top-20 w-full h-full bg-teal-800/30 hidden lg:block" 
                  style={{ 
                    clipPath: 'polygon(0 0, 100% 0, 100% 30%, 0 100%)',
                    background: 'linear-gradient(135deg, rgba(13, 148, 136, 0.3) 0%, rgba(15, 118, 110, 0.2) 100%)'
                  }}
                ></div>
              </div>

              <div className="grid lg:grid-cols-5 gap-0">
                {/* Doctor Image Column */}
                <motion.div 
                  variants={fadeInUp}
                  className="lg:col-span-2 relative"
                >
                  <div className="relative h-full min-h-[300px] sm:min-h-[400px] lg:min-h-[500px]">
                    <div className="absolute inset-0 bg-teal-900/10"></div>
                    <div className="absolute inset-4 sm:inset-8 rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20">
                      <img 
                        src="/Images/Dr_Nidhi.webp" 
                        alt="Dr. Nidhi Patel" 
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    {/* Experience badge - adjusted for mobile
                    <motion.div
                      initial={{ scale: 0, y: 50 }}
                      whileInView={{ scale: 1, y: 0 }}
                      transition={{ delay: 0.4, type: "spring" }}
                      className="absolute -bottom-4 sm:-bottom-6 left-1/2 -translate-x-1/2 bg-white px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg border-2 border-teal-400 whitespace-nowrap"
                    >
                      <span className="font-bold text-teal-800 text-xs sm:text-sm md:text-base" style={{ fontFamily: "'Montserrat', sans-serif" }}>15+ Years Experience</span>
                    </motion.div> */}
                  </div>
                </motion.div>
                
                {/* Bio Column */}
                <motion.div 
                  variants={staggerContainer}
                  className="lg:col-span-3 p-6 sm:p-8 md:p-10 lg:p-12 flex flex-col justify-center"
                >
                  <motion.div variants={fadeInUp}>
                    <div className="flex items-center mb-4 sm:mb-6">
                      <div className="w-8 sm:w-12 h-1 bg-teal-300 mr-3 sm:mr-4"></div>
                      {/* <span className="text-teal-300 uppercase tracking-widest text-xs sm:text-sm font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>Pediatric Specialist</span> */}
                    </div>
                    
                    <motion.h3 
                      variants={fadeInUp}
                      className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6 leading-tight"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                     <p>
  DR. <span className="text-teal-400 ">NIDHI</span> PATEL
  <br />
  MD Skin
  <br />
  Gold Medalist 🥇
</p>

                    </motion.h3>
                  </motion.div>
                  
                  {/* Career Timeline */}
                  <motion.div 
                    variants={fadeInUp}
                    className="mb-6 sm:mb-8 relative pl-6 sm:pl-8 border-l-2 border-teal-400/30"
                  >
                    {[
                      







{
  year: "2024-25",
  title: "Assistant Professor",
  institution: "GMERS Medical College, Patan"
},
{
  year: "2023-24",
  title: "Senior Resident (SR)",
  institution: "M.P Shah Government Medical College, Jamnagar"
},
{
  year: "2020-23",
  title: "MD in Dermatology",
  institution: "M.P Shah Government Medical College, Jamnagar"
},
{
  year: "2018-19",
  title: "Internship",
  institution: "GMERS Medical College, Valsad"
},
{
  year: "2013-18",
  title: "MBBS",
  institution: "GMERS Medical College, Valsad"
},

                    ].map((item, index) => (
                      <motion.div 
                        key={index}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.2 + index * 0.1 }}
                        className="mb-4 sm:mb-6 relative group"
                      >
                        <div className="absolute -left-6 sm:-left-8 top-1 w-4 sm:w-5 h-4 sm:h-5 rounded-full bg-teal-400 border-4 border-teal-600/50"></div>
                        <div className="text-teal-300 font-bold mb-1 text-sm sm:text-base" style={{ fontFamily: "'Montserrat', sans-serif" }}>{item.year}</div>
                        <h4 className="text-white text-base sm:text-lg font-semibold">{item.title}</h4>
                        <p className="text-teal-200 text-sm sm:text-base">{item.institution}</p>
                      </motion.div>
                    ))}
                  </motion.div>
                  
                  {/* Specializations - Adjusted for mobile */}
                  <motion.div 
                    variants={fadeInUp}
                    className="mb-6 sm:mb-8"
                  >
                    {/* <h4 className="text-white font-medium mb-2 sm:mb-3 text-sm sm:text-base" style={{ fontFamily: "'Montserrat', sans-serif" }}>Specializations:</h4> */}
                    {/* <div className="flex flex-wrap gap-2 sm:gap-3">
                      {[
                        "Genetic Skin Disorders",
                        "Ichthyosis Treatment",
                        "Epidermolysis Bullosa",
                        "Pediatric Dermatology",
                        "Research & Innovation"
                      ].map((item, index) => (
                        <motion.span
                          key={index}
                          initial={{ scale: 0 }}
                          whileInView={{ scale: 1 }}
                          transition={{ delay: 0.1 * index, type: "spring" }}
                          className="inline-block px-3 sm:px-4 py-1 sm:py-2 bg-teal-800/50 text-teal-100 rounded-full text-xs sm:text-sm border border-teal-600/50"
                        >
                          {item}
                        </motion.span>
                      ))}
                      
                    </div> */}
                    <h4 className="text-white font-medium mt-3 mb-2 sm:mb-3 text-sm sm:text-base" style={{ fontFamily: "'Montserrat', sans-serif" }}>Award:</h4>
                    {/* MD skin veneral disease and leprosy _Gold medalist */}
                      <h4 className="text-teal-200 font-medium mt-3 mb-2 sm:mb-3 text-sm sm:text-base" style={{ fontFamily: "'Montserrat', sans-serif" }}>MD skin veneral disease and leprosy Gold medalist</h4>
                    
                  </motion.div>
                </motion.div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
<section className="relative bg-white py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 overflow-hidden">
  {/* Simplified decorative elements */}
  <div className="absolute top-0 left-0 w-full h-full z-0 opacity-10">
    <div className="absolute top-20 left-4 sm:left-10 w-16 h-16 sm:w-24 sm:h-24 rounded-full bg-teal-100 blur-xl animate-float-slow"></div>
    <div className="absolute bottom-1/3 right-4 sm:right-16 w-20 h-20 sm:w-32 sm:h-32 rounded-full bg-amber-100 blur-xl animate-float-slow-delay"></div>
  </div>

  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    {/* Section Header - Faster animations starting earlier */}
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.6,
        type: "spring",
        stiffness: 150
      }}
      viewport={{ once: true, margin: "-100px" }}
      className="text-center mb-12 sm:mb-16"
    >
      <motion.h2 
        className="text-3xl xs:text-4xl sm:text-4xl md:text-5xl font-bold text-teal-900 mb-3 sm:mb-4" 
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 400, duration: 0.3 }}
      >
        About <motion.span 
          className="text-teal-600 inline-block"
          whileHover={{ 
            scale: 1.05,
            rotate: [0, -3, 3, 0],
          }}
          transition={{ duration: 0.4 }}
        >Dr. Nidhi Patel</motion.span>
      </motion.h2>
      <motion.div 
        className="w-20 sm:w-24 h-1 bg-teal-400 mx-auto"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        viewport={{ once: true, margin: "-50px" }}
      ></motion.div>
    </motion.div>

    {/* Top Row - Optimized animations */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center mb-12 sm:mb-16">
      {/* Main Photo - Faster animation */}
      <motion.div 
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ 
          duration: 0.6, 
          type: "spring",
          stiffness: 100
        }}
        viewport={{ once: true, margin: "-100px" }}
        className="relative h-full min-h-[300px] xs:min-h-[350px] sm:min-h-[400px] md:min-h-[450px] lg:min-h-[500px]"
      >
        <motion.div 
          className="rounded-lg md:rounded-xl overflow-hidden shadow-lg sm:shadow-xl lg:shadow-2xl h-full w-full relative"
          whileHover={{ 
            boxShadow: "0 15px 30px -5px rgba(16, 185, 129, 0.2)"
          }}
          transition={{ duration: 0.2 }}
        >
          <motion.img 
            src="/Images/dr-main.webp" 
            alt="Dr. Nidhi Patel" 
            className="w-full h-full object-cover object-center"
            loading="lazy"
            whileHover={{
              scale: 1.02,
              transition: { duration: 0.3 }
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
        </motion.div>
      </motion.div>

      {/* Info Content - Faster staggered animations */}
      <motion.div 
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ 
          duration: 0.6,
          type: "spring",
          stiffness: 100
        }}
        viewport={{ once: true, margin: "-100px" }}
        className="space-y-6 sm:space-y-8"
      >
        <motion.div 
          className="bg-gradient-to-br from-teal-50 to-white p-6 sm:p-8 rounded-lg md:rounded-xl shadow-md sm:shadow-lg border border-teal-100"
          whileHover={{ 
            y: -3,
            boxShadow: "0 8px 20px -5px rgba(16, 185, 129, 0.15)"
          }}
          transition={{ duration: 0.2 }}
        >
          <p className="text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed font-medium mb-4 sm:mb-6">
            With over a decade of specialized experience, <span className="font-bold text-teal-700 bg-teal-100/50 px-1 rounded">Dr. Nidhi Patel</span> combines medical expertise with compassionate care.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Her patient-centered approach addresses both the clinical and emotional aspects of dermatological health, ensuring comprehensive care tailored to each individual's needs.
          </p>
        </motion.div>
        
        <div className="space-y-4 sm:space-y-6">
          {[
            {
              title: "Board Certified",
              text: "Dermatologist with advanced training in cosmetic and medical dermatology"
            },
            {
              title: "Innovative Pioneer",
              text: "Specializing in cutting-edge treatments using evidence-based approaches"
            },
            {
              title: "Personalized Care",
              text: "Committed to addressing each patient's unique needs and concerns"
            }
          ].map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, x: 10 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ 
                duration: 0.4,
                delay: index * 0.1
              }}
              viewport={{ once: true, margin: "-50px" }}
              className="flex items-start bg-white p-4 sm:p-5 rounded-lg shadow-sm border-l-4 border-teal-400 hover:border-teal-600 transition-all"
              whileHover={{ 
                x: 3,
                transition: { type: "spring", stiffness: 400, duration: 0.2 }
              }}
            >
              <div className="flex-shrink-0 mt-1 p-1.5 sm:p-2 bg-teal-100 rounded-lg hover:bg-teal-200 transition-colors">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <div className="ml-3 sm:ml-4">
                <h3 className="text-base sm:text-lg font-bold text-teal-800">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-700">{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>

    {/* Gallery Section - Optimized animations */}
    <section className="py-20 bg-gradient-to-br from-teal-100 via-white to-teal-100">
      <h3 
        className="text-4xl md:text-5xl font-bold text-center mb-16 text-gray-800"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Our <span className="text-teal-600">Gallery</span>
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-6 md:px-16">
        {[
          { id: 1, file: "s1.webp", title: "Consultation", desc: "Personalized Care" },
          { id: 2, file: "s2.webp", title: "Treatment", desc: "Precision Techniques" },
          { id: 3, file: "s3.webp", title: "Technology", desc: "State-of-the-Art Equipment" },
          { id: 4, file: "s4.webp", title: "Results", desc: "Proven Transformations" }
        ].map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.5, 
              delay: index * 0.1,
              type: "spring",
              stiffness: 100
            }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative group overflow-hidden rounded-2xl bg-white border border-white/30 shadow-lg"
          >
            <img 
              src={`/Images/Gallery/${item.file}`} 
              alt={item.title} 
              className="w-full h-64 sm:h-80 object-cover object-center group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex flex-col justify-end p-5">
              <h4 className="text-white text-xl font-bold mb-1">{item.title}</h4>
              <p className="text-teal-100 text-sm">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
 

    {/* CTA Section - Responsive button */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.6, 
        delay: 1,
        type: "spring",
        stiffness: 80
      }}
      viewport={{ once: true }}
      className="text-center"
    >
      <motion.div
        whileHover={{ 
          scale: 1.02,
          transition: { type: "spring", stiffness: 400 }
        }}
      >
        <Link 
          to="/about" 
          className="inline-flex items-center px-6 py-3 sm:px-8 sm:py-4 border border-transparent text-base sm:text-lg font-medium rounded-lg md:rounded-xl text-white bg-gradient-to-r from-teal-600 to-teal-500 hover:from-teal-700 hover:to-teal-600 transition-all duration-300 shadow-md sm:shadow-lg hover:shadow-teal-200/50"
        >
          <span className="mr-2 sm:mr-3">Learn More About Our Practice</span>
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
          </svg>
        </Link>
      </motion.div>
    </motion.div>
  </div>
</section>


       <Treatments />
       <Procedures />
        <Footer/>
    </div>
  );
};

export default Home;